import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ProductShowcase from "@/components/ProductShowcase";
import About from "@/components/About";
import Footer from "@/components/Footer";

export default function Home() {
  const location = useLocation();

  const scrollToShop = () => {
    const el = document.getElementById("shop");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    // Small delay so target sections are mounted.
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <>
      <Header />
      <main>
        <Hero onShopClick={scrollToShop} />
        <ProductShowcase />
        <About />
      </main>
      <Footer />
    </>
  );
}
